import React from 'react'

import * as S from './typography.styled'
import { TypographyProps } from './typography.types'

export const Typography = ({
  children,
  size = 'text-medium',
  weight,
  as = 'p',
  // NOTE: undefined is intentional
  breakLines = undefined,
  textTransform,
  textAlign,
  whiteSpace,
  wordBreak,
  color,
  ...rest
}: TypographyProps) => {
  return (
    <S.Typography
      {...rest}
      as={as}
      $color={color}
      $size={size}
      $weight={weight}
      $breakLines={breakLines}
      $textTransform={textTransform}
      $textAlign={textAlign}
      $whiteSpace={whiteSpace}
      $wordBreak={wordBreak}
      data-component-id="Typography"
    >
      {children}
    </S.Typography>
  )
}
